function drawerForm() {
  const containerForm = document.querySelector('.product-drawer_content-bottom');
  if (!containerForm) {
    return;
  }

  const productVariants = JSON.parse(containerForm.dataset.variants);
  const shopCurrency = containerForm.dataset.currency;
  const moneyFormat = containerForm.dataset.moneyFormat;

  // const colorFieldset = containerForm.querySelector('.product-colors');
  // const colorRadios = colorFieldset?.querySelectorAll('input[type="radio"]') || [];
  // const colorSwatches = colorFieldset?.querySelectorAll('.color-swatch') || [];

  // colorSwatches.forEach((swatch, index) => {
  //   swatch.addEventListener('click', function() {
  //     console.log('--------colorSwatches---------')
  //     swatch.style.borderColor = '#000';
  //     colorRadios[index].checked = true;
  //     colorSwatches.forEach((s, i) => {
  //       console.log('index:', index)
  //       if (i !== index) {
  //         s.style.borderColor = '#ccc';
  //       }
  //     });
  //     colorRadios[index].dispatchEvent(new Event('change'));
  //   });
  // });

  const variantInput = containerForm.querySelector('[data-variant-id]');
  const optionInputs = containerForm.querySelectorAll('[name^="options"]');
  const addToCartBtn = containerForm.querySelector('.add-to-cart');
  const priceEl = containerForm.querySelector('.product-price');

  function updateVariant() {
    const selectedOptions = [];
    optionInputs.forEach(input => {
      // ✅ Only push real, selected values
      if (input.type === 'radio' && input.checked) {
        selectedOptions.push(input.value);
      } else if (input.tagName === 'SELECT' && input.value && input.value !== '') {
        selectedOptions.push(input.value);
      }
    });

    // ✅ Number of options the product actually has (Color, Size, etc.)
    const totalOptions = productVariants[0]?.options.length || 0;

    // ✅ Only attempt to find a variant when all options are selected
    let matchingVariant = null;
    if (selectedOptions.length === totalOptions && totalOptions > 0) {
      matchingVariant = productVariants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
    }

    if (matchingVariant) {
      // Update hidden variant input
      variantInput.value = matchingVariant.id;

      priceEl.innerText =
        theme.Currency.formatMoney(matchingVariant.price, moneyFormat) +
        ' ' +
        shopCurrency;

      // Enable or disable Add to Cart
      if (matchingVariant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add To Cart';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold Out';
      }
    } else {
      // No matching variant (invalid option combination or not all options selected)
      if (selectedOptions.length > 0) {
        // ✅ At least one option selected → keep button enabled
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add To Cart';
      } else {
        // ✅ Nothing selected at all → keep disabled
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Add To Cart';
      }
    }
  }

  optionInputs.forEach(input => input.addEventListener('change', updateVariant));
  updateVariant();
}
